import { apiFetch, Code, FetchReturn, noAuthApiFetch } from "../../lib/utils";

export interface IMemberInvoiceReviewItem {
  invoiceNumber: string;
  contractId: string;
  billingDate: Date;
  priceExcMoms: number;
  priceIncMoms: number;
  status: number;
  type: number;
}

export enum ReviewStatus {
  NEW = 0,
  OPENED = 1,
  APPROVED = 2,
  DEVIATION = 3,
  REOPENED = 5
}

export interface IMemberInvoiceReview {
  provider: string;
  providerName: string;
  customer: string;
  period: Date;
  endPeriod: Date; // Added endPeriod field
  status: ReviewStatus;
  invoices: IMemberInvoiceReviewItem[];
}

const ENDPOINT = "/MemberInvoiceReview";

const GetByKey = async (key: string): Promise<IMemberInvoiceReview> => {
  const response = await noAuthApiFetch(`${ENDPOINT}/${key}`, 'GET', null, { 'Content-Type': 'application/json' });
  const memberInvoiceReview = (await response.json()) as IMemberInvoiceReview;

  // Convert both period and endPeriod to Date objects
  memberInvoiceReview.period = new Date(memberInvoiceReview.period);
  memberInvoiceReview.endPeriod = new Date(memberInvoiceReview.endPeriod);
  memberInvoiceReview.invoices.forEach(i => {
    i.billingDate = new Date(i.billingDate)
  });
  return memberInvoiceReview;
};

const PostStatus = async (
  key: string,
  status: number,
  comment: string | null,
  hasFiles: boolean,
  amountCorrect?: boolean | null,
  quantityCorrect?: boolean | null,
  labelCorrect?: boolean | null
) => {
  // Build the request body, conditionally adding optional fields
  const body: any = {
    status: status,
    comment: comment || "", // Send comment, default to empty string if null
    hasFiles: hasFiles,
  };

  // Only add the fields if they are not undefined
  if (amountCorrect !== undefined) body.amountCorrect = amountCorrect;
  if (quantityCorrect !== undefined) body.quantityCorrect = quantityCorrect;
  if (labelCorrect !== undefined) body.labelCorrect = labelCorrect;

  console.log('PostStatus', body);
  const response = await noAuthApiFetch(`${ENDPOINT}/${key}/status`, 'POST', JSON.stringify(body), { 'Content-Type': 'application/json' });
  return response;
};

const PostFiles = async (key: string, files: File[]) => {
  const data = new FormData();
  files.forEach((f, i) => data.append(`formFiles`, f, f.name));
  const response = await noAuthApiFetch(`${ENDPOINT}/${key}/upload`, 'POST', data);
  return response;
};

export {
  GetByKey,
  PostStatus,
  PostFiles
};
